var map = {
	"./da.json": [
		"./src/js/translations/da.json",
		"src_js_translations_da_json"
	],
	"./de.json": [
		"./src/js/translations/de.json",
		"src_js_translations_de_json"
	],
	"./en.json": [
		"./src/js/translations/en.json",
		"src_js_translations_en_json"
	],
	"./es.json": [
		"./src/js/translations/es.json",
		"src_js_translations_es_json"
	],
	"./fr.json": [
		"./src/js/translations/fr.json",
		"src_js_translations_fr_json"
	],
	"./it.json": [
		"./src/js/translations/it.json",
		"src_js_translations_it_json"
	],
	"./nl.json": [
		"./src/js/translations/nl.json",
		"src_js_translations_nl_json"
	],
	"./no.json": [
		"./src/js/translations/no.json",
		"src_js_translations_no_json"
	],
	"./pt-BR.json": [
		"./src/js/translations/pt-BR.json",
		"src_js_translations_pt-BR_json"
	],
	"./ru.json": [
		"./src/js/translations/ru.json",
		"src_js_translations_ru_json"
	],
	"./sv.json": [
		"./src/js/translations/sv.json",
		"src_js_translations_sv_json"
	],
	"./whitelist_en.json": [
		"./src/js/translations/whitelist_en.json",
		"src_js_translations_whitelist_en_json"
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__.t(id, 3 | 16);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = "./src/js/translations lazy recursive ^\\.\\/.*\\.json$";
module.exports = webpackAsyncContext;